/**
 * RoleAwareDashboard — Routes the /dashboard URL to the appropriate dashboard:
 *   • super_admin / country_operator → CustomizableDashboard (new draggable widgets)
 *   • Everyone else                  → existing subscriber DashboardPage (unchanged)
 *
 * Subscribers can opt into the draggable view via the existing
 * dashboard page if/when we make it draggable too. For now this is the
 * lowest-risk wiring: NEW dashboards for admins, ZERO change for subscribers.
 */
import { useAuth } from '../contexts/AuthContext';
import DashboardPage from './DashboardPage';
import CustomizableDashboard from '../components/CustomizableDashboard';

export default function RoleAwareDashboard() {
  const { user, effectiveRole } = useAuth();
  const role = effectiveRole || user?.role;
  if (role === 'super_admin' || role === 'country_operator') {
    return <CustomizableDashboard />;
  }
  return <DashboardPage />;
}
